import { Button, Dialog, HStack, Input, Portal, Text } from '@chakra-ui/react';
import { toaster } from '@/components/ui/toaster';

/**
 * Shows a generated one-time set-password link for the admin to copy and send
 * manually. Always mounted; visibility is driven by `url` being non-null
 * (Chakra v3 controlled pattern — same as VoidPaymentDialog).
 */
export function SetupLinkDialog({ url, onClose }: { url: string | null; onClose: () => void }) {
  const open = url != null;
  return (
    <Dialog.Root
      open={open}
      size="md"
      finalFocusEl={() => document.body}
      onOpenChange={(d) => {
        if (!d.open) onClose();
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Enlace de contraseña</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Text fontSize="sm" color="fg.muted" mb="3">
                Compártelo con el usuario (WhatsApp, etc.). Válido 24 horas · un solo uso.
              </Text>
              <HStack gap="2">
                <Input
                  aria-label="Enlace de contraseña"
                  readOnly
                  value={url ?? ''}
                  fontSize="sm"
                  onFocus={(e) => e.currentTarget.select()}
                />
                <Button
                  colorPalette="brand"
                  bg="brand.600"
                  color="white"
                  _hover={{ bg: 'brand.700' }}
                  flexShrink={0}
                  onClick={async () => {
                    if (!url) return;
                    try {
                      await navigator.clipboard.writeText(url);
                      toaster.create({ title: 'Enlace copiado', type: 'success' });
                    } catch {
                      toaster.create({
                        title: 'Copia manual',
                        description: 'Selecciona y copia el enlace.',
                        type: 'info',
                      });
                    }
                  }}
                >
                  Copiar
                </Button>
              </HStack>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="ghost" onClick={onClose}>
                Cerrar
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
